import React from "react";
import { ResourceAvatar } from "@common/resourceAvatar";
import { TrashIcon } from "@common/trashIcon";
import { Safeguard } from "@scenes/safeguard";
import { UseCases } from "@planzone/core";
import { useModal } from "@root/client/modal";
import { MarkDownContent } from "../../markDownContent";
import { Props } from "./types";
import styles from "./styles.scss";

function Reply({ comment, resources }: Props) {
  const submissionDate = new Date(comment.createdDate);
  const { pushView } = useModal();

  return (
    <div className={styles.reply}>
      <div className={styles.avatar}>
        <ResourceAvatar resource={comment.author} />
      </div>
      <div className={styles.main}>
        <div className={styles.header}>
          <span className={styles.author}>{comment.author.name}</span>
          <span className={styles.date}>
            {submissionDate.toLocaleDateString()} {submissionDate.getHours()}h
            {submissionDate.getMinutes()}
          </span>
        </div>
        <div className={styles.content}>
          {comment.content.trim().startsWith("<") ? (
            <div
              dangerouslySetInnerHTML={{
                __html: MarkDownContent.styleMentions(
                  comment.content,
                  (comment.recipients.length > 0
                    ? comment.recipients
                    : resources
                  )
                    .map(({ name }) => name)
                    .filter((name) => name !== comment.replyTo?.author.name),
                ),
              }}
            />
          ) : (
            <p>
              <MarkDownContent
                content={comment.content}
                replacements={{
                  [MarkDownContent.ExpressionTypes.TEXT]: (text) => (
                    <span>{text}</span>
                  ),
                  [MarkDownContent.ExpressionTypes.RESOURCE]: (text) => (
                    <span style={{ color: "#269FFF" }}>{text}</span>
                  ),
                }}
                resources={
                  comment.recipients.length > 0 ? comment.recipients : resources
                }
              />
            </p>
          )}
        </div>
      </div>
      <Safeguard useCases={[UseCases.removeComment]} context={{ comment }}>
        {({ canRemoveComment }) =>
          canRemoveComment ? (
            <div
              className={styles.iconBox}
              onClick={() =>
                pushView({ key: UseCases.removeComment, data: comment })
              }
            >
              <TrashIcon className={styles.icon} />
            </div>
          ) : (
            <div className={styles.iconBox}>
              <div className={styles.icon} />
            </div>
          )
        }
      </Safeguard>
    </div>
  );
}

export { Reply };
